module.exports = __webpack_public_path__ + "static/media/Polygon.51df7d11.svg";